var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"general-info"}},[_c('div',{attrs:{"id":"links"}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"gifts"}},[_vm._v(" Virtual Gifts ")]),(_vm.roomProfile.motd)?_c('router-link',{staticClass:"nav-link",attrs:{"to":"rules"}},[_vm._v(" Room Rules ")]):_vm._e()],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }